import CallBackInvestment from './CallBackInvestment';
export default CallBackInvestment;
